import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex align-items-center justify-content-between flex-wrap gap-3" }
const _hoisted_2 = { class: "flex align-items-center gap-2 flex-wrap" }
const _hoisted_3 = { class: "flex flex-column gap-4" }
const _hoisted_4 = { class: "flex flex-column gap-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "text-primary-50",
  for: "me-period"
}, "Billing period", -1)
const _hoisted_6 = { class: "flex flex-column gap-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  class: "text-primary-50",
  for: "me-var"
}, "Variable", -1)
const _hoisted_8 = { class: "flex flex-column" }
const _hoisted_9 = { class: "text-color-secondary" }
const _hoisted_10 = { class: "flex flex-column gap-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  class: "text-primary-50",
  for: "me-value"
}, "Value", -1)
const _hoisted_12 = { class: "flex flex-column gap-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  class: "text-primary-50",
  for: "me-text"
}, "Value text (optional)", -1)
const _hoisted_14 = { class: "flex flex-column gap-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  class: "text-primary-50",
  for: "me-notes"
}, "Notes (optional)", -1)
const _hoisted_16 = { class: "flex align-items-center justify-content-end gap-3" }
const _hoisted_17 = { class: "flex flex-column gap-4" }
const _hoisted_18 = { class: "m-0 text-sm" }
const _hoisted_19 = { class: "flex flex-column gap-2" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  class: "text-primary-50",
  for: "approve-notes"
}, "Notes (optional)", -1)
const _hoisted_21 = { class: "flex align-items-center justify-content-end gap-3" }
const _hoisted_22 = { class: "flex flex-column gap-4" }
const _hoisted_23 = { class: "m-0 text-sm" }
const _hoisted_24 = { class: "flex flex-column gap-2" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  class: "text-primary-50",
  for: "reject-notes"
}, "Reason (optional)", -1)
const _hoisted_26 = { class: "flex align-items-center justify-content-end gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WTitle = _resolveComponent("WTitle")!
  const _component_PDropdown = _resolveComponent("PDropdown")!
  const _component_PButton = _resolveComponent("PButton")!
  const _component_PColumn = _resolveComponent("PColumn")!
  const _component_PTag = _resolveComponent("PTag")!
  const _component_PDataTable = _resolveComponent("PDataTable")!
  const _component_PCard = _resolveComponent("PCard")!
  const _component_PInputNumber = _resolveComponent("PInputNumber")!
  const _component_PInputText = _resolveComponent("PInputText")!
  const _component_PDialog = _resolveComponent("PDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PCard, null, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_WTitle, { text: "Manual Entries" }),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_PDropdown, {
              options: _ctx.periodOptions,
              showClear: true,
              optionLabel: "label",
              optionValue: "value",
              placeholder: "All periods",
              style: {"min-width":"10rem"},
              modelValue: _ctx.filterPeriodId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterPeriodId) = $event)),
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.refreshList()))
            }, null, 8, ["options", "modelValue"]),
            _createVNode(_component_PDropdown, {
              options: _ctx.statusOptions,
              showClear: true,
              optionLabel: "label",
              optionValue: "value",
              placeholder: "All statuses",
              style: {"min-width":"9rem"},
              modelValue: _ctx.filterStatus,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterStatus) = $event)),
              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.refreshList()))
            }, null, 8, ["options", "modelValue"]),
            (_ctx.canCreate)
              ? _withDirectives((_openBlock(), _createBlock(_component_PButton, {
                  key: 0,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openSubmit())),
                  icon: "pi pi-plus",
                  label: "Submit",
                  rounded: "",
                  size: "small"
                }, null, 512)), [
                  [
                    _directive_tooltip,
                    `Submit a manual entry`,
                    void 0,
                    { left: true }
                  ]
                ])
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      content: _withCtx(() => [
        _createVNode(_component_PDataTable, {
          alwaysShowPaginator: false,
          loading: _ctx.loading,
          rowHover: true,
          rows: 50,
          showGridlines: true,
          stripedRows: true,
          value: _ctx.list,
          "data-key": "id",
          paginator: "",
          size: "small"
        }, {
          empty: _withCtx(() => [
            _createTextVNode("No manual entries found.")
          ]),
          default: _withCtx(() => [
            _createVNode(_component_PColumn, {
              field: "period_name",
              header: "Period",
              headerClass: "py-3",
              sortable: ""
            }),
            _createVNode(_component_PColumn, {
              field: "variable_name",
              header: "Variable",
              headerClass: "py-3",
              sortable: ""
            }),
            _createVNode(_component_PColumn, {
              field: "category",
              header: "Category",
              headerClass: "py-3",
              sortable: ""
            }),
            _createVNode(_component_PColumn, {
              field: "value",
              header: "Value",
              headerClass: "py-3",
              sortable: ""
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.displayValue(data)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_PColumn, {
              field: "status",
              header: "Status",
              headerClass: "py-3",
              style: {"width":"110px"}
            }, {
              body: _withCtx(({ data }) => [
                _createVNode(_component_PTag, {
                  severity: _ctx.statusSeverity(data.status)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(data.status), 1)
                  ]),
                  _: 2
                }, 1032, ["severity"])
              ]),
              _: 1
            }),
            _createVNode(_component_PColumn, {
              field: "submitted_by_username",
              header: "Submitted by",
              headerClass: "py-3",
              sortable: ""
            }),
            _createVNode(_component_PColumn, {
              field: "submitted_at",
              header: "Submitted at",
              headerClass: "py-3"
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(data.submitted_at)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_PColumn, {
              field: "approved_by_username",
              header: "Decided by",
              headerClass: "py-3"
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", null, _toDisplayString(data.approved_by_username || '—'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_PColumn, {
              field: "approved_at",
              header: "Decided at",
              headerClass: "py-3"
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(data.approved_at)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_PColumn, {
              field: "notes",
              header: "Notes",
              headerClass: "py-3"
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", null, _toDisplayString(data.notes || '—'), 1)
              ]),
              _: 1
            }),
            (_ctx.canApprove)
              ? (_openBlock(), _createBlock(_component_PColumn, {
                  key: 0,
                  bodyClass: "text-right",
                  headerClass: "py-3",
                  style: {"width":"110px"}
                }, {
                  body: _withCtx(({ data }) => [
                    (data.status === 'pending')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _withDirectives(_createVNode(_component_PButton, {
                            disabled: _ctx.isOwnEntry(data),
                            onClick: ($event: any) => (_ctx.openApprove(data)),
                            icon: "pi pi-check",
                            rounded: "",
                            severity: "success",
                            size: "small",
                            text: ""
                          }, null, 8, ["disabled", "onClick"]), [
                            [
                              _directive_tooltip,
                              _ctx.isOwnEntry(data)
									? 'Four-eyes: you cannot approve your own entry'
									: 'Approve',
                              void 0,
                              { bottom: true }
                            ]
                          ]),
                          _withDirectives(_createVNode(_component_PButton, {
                            disabled: _ctx.isOwnEntry(data),
                            onClick: ($event: any) => (_ctx.confirmReject($event, data)),
                            icon: "pi pi-times",
                            rounded: "",
                            severity: "danger",
                            size: "small",
                            text: ""
                          }, null, 8, ["disabled", "onClick"]), [
                            [
                              _directive_tooltip,
                              _ctx.isOwnEntry(data)
									? 'Four-eyes: you cannot reject your own entry'
									: 'Reject',
                              void 0,
                              { bottom: true }
                            ]
                          ])
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["loading", "value"])
      ]),
      _: 1
    }),
    _createVNode(_component_PDialog, {
      header: "Submit manual entry",
      onHide: _cache[12] || (_cache[12] = ($event: any) => (_ctx.closeSubmit())),
      modal: "",
      style: {"width":"28rem","max-width":"95vw"},
      visible: _ctx.showSubmit,
      "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.showSubmit) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_PDropdown, {
              options: _ctx.eligiblePeriodOptions,
              id: "me-period",
              optionLabel: "label",
              optionValue: "value",
              placeholder: "Select period",
              modelValue: _ctx.form.billing_period_id,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.billing_period_id) = $event))
            }, null, 8, ["options", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_PDropdown, {
              options: _ctx.catalog,
              id: "me-var",
              optionLabel: "name",
              optionValue: "id",
              placeholder: "Select variable",
              modelValue: _ctx.form.variable_id,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.variable_id) = $event))
            }, {
              option: _withCtx(({ option }) => [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", null, _toDisplayString(option.name), 1),
                  _createElementVNode("small", _hoisted_9, _toDisplayString(option.category) + " · " + _toDisplayString(option.unit || '—'), 1)
                ])
              ]),
              _: 1
            }, 8, ["options", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_PInputNumber, {
              maxFractionDigits: 5,
              id: "me-value",
              inputClass: "w-full",
              modelValue: _ctx.form.value,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.value) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode(_component_PInputText, {
              id: "me-text",
              size: "small",
              modelValue: _ctx.form.value_text,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.value_text) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_PInputText, {
              id: "me-notes",
              size: "small",
              modelValue: _ctx.form.notes,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.notes) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_PButton, {
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.doSubmit())),
              label: "Submit",
              size: "small"
            }),
            _createVNode(_component_PButton, {
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.closeSubmit())),
              label: "Cancel",
              outlined: "",
              severity: "secondary",
              size: "small"
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_PDialog, {
      header: "Approve manual entry",
      modal: "",
      style: {"width":"24rem","max-width":"95vw"},
      visible: _ctx.showApprove,
      "onUpdate:visible": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.showApprove) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("p", _hoisted_18, [
            _createTextVNode(" Approve "),
            _createElementVNode("strong", null, _toDisplayString(_ctx.approveTarget?.variable_name), 1),
            _createTextVNode(" for "),
            _createElementVNode("strong", null, _toDisplayString(_ctx.approveTarget?.period_name), 1),
            _createTextVNode(" and apply to settlement variables? ")
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createVNode(_component_PInputText, {
              id: "approve-notes",
              size: "small",
              modelValue: _ctx.decisionNotes,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.decisionNotes) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_PButton, {
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.doApprove())),
              label: "Approve",
              severity: "success",
              size: "small"
            }),
            _createVNode(_component_PButton, {
              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showApprove = false)),
              label: "Cancel",
              outlined: "",
              severity: "secondary",
              size: "small"
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_PDialog, {
      header: "Reject manual entry",
      modal: "",
      style: {"width":"24rem","max-width":"95vw"},
      visible: _ctx.showReject,
      "onUpdate:visible": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.showReject) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("p", _hoisted_23, [
            _createTextVNode(" Reject "),
            _createElementVNode("strong", null, _toDisplayString(_ctx.rejectTarget?.variable_name), 1),
            _createTextVNode(" for "),
            _createElementVNode("strong", null, _toDisplayString(_ctx.rejectTarget?.period_name), 1),
            _createTextVNode("? ")
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createVNode(_component_PInputText, {
              id: "reject-notes",
              size: "small",
              modelValue: _ctx.decisionNotes,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.decisionNotes) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_PButton, {
              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.doReject())),
              label: "Reject",
              severity: "danger",
              size: "small"
            }),
            _createVNode(_component_PButton, {
              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.showReject = false)),
              label: "Cancel",
              outlined: "",
              severity: "secondary",
              size: "small"
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}